import WoocommerceChooseAccount from "../Layout/stepUtils/WoocommerceChooseAccount";
import { AddWcWebhook } from "../Layout/Woocommerce/AddWcWebhook";

const WOOCOMMERCE_COMMON = [
  {
    title: "Choosed Account",
    content: () => <WoocommerceChooseAccount />,
  },
];

//woocommerce flow steps
const WC_NEW_PRODUCT = {
  steps: [
    ...WOOCOMMERCE_COMMON,
    {
      title: "Connect Webhook",
      content: () => <AddWcWebhook />,
    },
  ],
};

const WC_NEW_CUSTOMER = {
  steps: [
    ...WOOCOMMERCE_COMMON,
    {
      title: "Connect Webhook",
      content: () => <AddWcWebhook />,
    },
  ],
};

const WC_NEW_ORDER = {
  steps: [...WOOCOMMERCE_COMMON],
};

const WC_UPDATED_ORDER = {
  steps: [
    ...WOOCOMMERCE_COMMON,
    {
      title: "Connect Webhook",
      content: () => <AddWcWebhook />,
    },
  ],
};
export { WC_NEW_PRODUCT, WC_NEW_CUSTOMER, WC_NEW_ORDER, WC_UPDATED_ORDER };
